import {ReactComponent as Check} from "../../../../images/icons/check.svg"
import {IWhyReason} from "./WhyYouShouldTrySection";
import React from "react";

interface Props{
    reason: IWhyReason;
}
const WhyItem = ({reason}: Props) => {
    return (
        <div>
            <div className="flex gap-[18px]">
                <Check/>
                <h3 className="text-[36px] leading-[44px] font-medium text-[#252429]">{reason.title}</h3>
            </div>
            <p className="text-[20px] leading-[30px] text-[#252429] pl-[5px] sm:pl-[62px]">{reason.description}</p>
        </div>
    )
};

export default WhyItem;
